import { FieldsOptionsType } from "@/common/types";
import { cn } from "@/common/utils";
import { Checkbox } from "antd";

interface CheckboxGroupWithLabelProps {
  name: string;
  options: FieldsOptionsType[];
  className?: string;
  value?: (string | number)[];
  onChange?: (value: (string | number)[]) => void;
}

const CheapFormComponent = ({
  name,
  options,
  className,
  value = [],
  onChange,
}: CheckboxGroupWithLabelProps) => {
  return (
    <Checkbox.Group
      name={name}
      className={className}
      value={value}
      onChange={onChange}
      rootClassName="gap-2"
    >
      {options.map((option) => (
        <div key={option.value} className="flex items-center gap-2">
          <label
            htmlFor={`${name}-${option.value}`}
            className={cn(
              "px-3 py-2 font-kanit text-base border border-black rounded-lg text-nowrap cursor-pointer transition",
              "hover:border-primary hover:text-primary",
              value.includes(option.value) && "border-primary text-primary"
            )}
          >
            {option.label}
            <Checkbox
              value={option.value}
              id={`${name}-${option.value}`}
              className="visually-hidden"
            />
          </label>
        </div>
      ))}
    </Checkbox.Group>
  );
};

export default CheapFormComponent;
